var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.filled)?_c('div',{staticClass:"flix-col-md-12 flix-text-center"},[_c('h2',[_vm._v("Danke für das Feedback!")])]):_vm._e(),_c('div',{class:_vm.getClass()},[_c('div',{ref:"hitklickContainer"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }